export const EditorTypeToAnalyticSourceMap = {
  deployments_onboarding: 'deploymentsGettingStartedScreen',
  pipelines_onboarding: 'pipelinesGettingStartedScreen',
  source: 'pipelinesEditorScreen',
  pipelines_onboarding_enable: 'pipelinesGettingStartedScreen',
};
